import React, { useEffect } from 'react';


function Login({loggedIn, loggedOut}) {

    useEffect(() => {

        const cloudkitConfig = {
        services: {
            // Use the browser's fetch implementation
            fetch: window.fetch,
            logger: console
        },
        containers: [{
            containerIdentifier: 'iCloud.taps',
            // environment: 'development',
            // apiTokenAuth: {
            //     apiToken: 'aa4bb8106108b888a6d0d7f6ae1c51dbd48d92f462304c3f4e5bb39188e225bd',
            //     persist: true,
            // },
            environment: 'production',
            apiTokenAuth: {
                apiToken: '77594c57ff9dc66d92594fbc6f810d8307ce204e24b3b33e57fde36de93f3f6b',
                persist: true,
            },
            signInButton: {
                id: 'apple-sign-in-button',
                theme: 'black'
            },
            signOutButton: {
                id: 'apple-sign-out-button',
                theme: 'black'
            }
        }]
        };  

        window.CloudKit.configure(cloudkitConfig);
        const container = window.CloudKit.getDefaultContainer();
        container.setUpAuth()
            .then((userIdentity) => {

                if(userIdentity) {
                    loggedIn(userIdentity); 
                }
                container
                    .whenUserSignsIn()
                    .then(userIdentity => loggedIn(userIdentity))
                    .catch(error => loggedOut(error));
            
                container
                    .whenUserSignsOut()
                    .then(loggedOut);

            })
    });
    
  

    return (
        <div className="auth-container">
            <div id="apple-sign-in-button"></div>
            <div id="apple-sign-out-button"></div>
        </div>
    );
}

export default Login;